import { useCallback, useContext, useRef, useEffect } from 'react'
import useGeneralApi from './useGeneralApi'
import useAuthApi from './useAuthApi'
import utils from '../utils/utils'
import { getFormattedTokenInBase64 } from '../utils/player.utils'
import { GlobalContext } from '../context/global.context'
/* --------------------------------------------- */
const usePlayerApi = () => {
  const { getData } = useGeneralApi()
  const { verifySession } = useAuthApi()
  const { userToken } = useContext(GlobalContext)
  const userTokenRef = useRef(userToken)
  /* --------------------------------------------- */
  useEffect(() => {
    userTokenRef.current = userToken
  }, [userToken])
  /* --------------------------------------------- */
  const getParsedSMIL = useCallback((url) => {
    return verifySession('', () => {
      const Authorization = getFormattedTokenInBase64(userTokenRef.current)
      return getData(url, {}, { Authorization }, {}, { isDoNotSetSessionId: true }).then(response => utils.parseXML(response))
    }, { url })
  }, [getData, verifySession])
  /* --------------------------------------------- */
  return { getParsedSMIL }
}
/* --------------------------------------------- */
export default usePlayerApi
